export default __webpack_public_path__ + "static/media/ndmi.91c52eaa.png";